/*
 * useIsWishlist - хук который позволяет узнать находится товар в избранном
 * */

import { useAppSelector } from '@redux/hooks';

export const useIsWishlist = (productId: number): boolean => {
  const wishList = useAppSelector(state => state.productManagement.wishList);
  return !!wishList?.find(x => x.id === productId);
};
